import { TableRow, TableCell, TextField, CircularProgress, Box } from "@mui/material";
import { FC, useEffect, useRef, useState } from "react";
import { IProforma } from "../../../../interfaces/IProforma";
import InvoicesController from "../../../../Api/invoicesController";
import { useToast } from "../../../../hooks/useToast";
import styled from "@emotion/styled";


const CopyBox = styled(Box)({
    border: "1px solid #e0e0e0",
    borderRadius: 8,
    background: "#f8fafc",
    padding: "8px 16px",
    margin: 8,
    fontSize: 15,
    cursor: "pointer",
    userSelect: "text",
    transition: "border-color 0.2s",
    whiteSpace: "pre-line",
    "&:hover": { borderColor: "#1976d2" },
});


interface PositionItemProps {
    invoiceId: string,
    pos: IProforma['positions'][number];
}

const PositionItem: FC<PositionItemProps> = ({ invoiceId, pos }) => {
    const [zd, setZd] = useState<string>(pos.zd || "");
    const [zdLoading, setZdLoading] = useState<boolean>(false);
    const zdTimeout = useRef<NodeJS.Timeout | null>(null);
    const toast = useRef(useToast()).current

    const handleChangeZd = (value: string) => {
        let firstValue = pos.zd;
        setZd(value);
        setZdLoading(true);
        if (zdTimeout.current) clearTimeout(zdTimeout.current);
        zdTimeout.current = setTimeout(async () => {
            const res = await InvoicesController.editProformaPositionZd({ invoiceId: invoiceId, positionId: pos._id, zd: value });
            if (!res.ok) {
                setZdLoading(false);
                toast.error(res.message);
                setZd(firstValue);
                return;
            }
            setZdLoading(false);
        }, 1500);
    }

    useEffect(() => {
        return () => {
            if (zdTimeout.current) clearTimeout(zdTimeout.current);
        };
    }, []);


    return (
        <TableRow key={pos._id}>
            <TableCell sx={{ width: "16%", p: 0 }}>
                <CopyBox
                    onContextMenu={e => {
                        e.preventDefault();
                        pos.name && navigator.clipboard.writeText(pos.name);
                    }}
                    title="Kliknij prawym, aby skopiować nazwę"
                >
                    {pos.name || "-"}
                </CopyBox>
            </TableCell>
            <TableCell sx={{ width: "20%", p: 0 }}>
                <CopyBox
                    onContextMenu={e => {
                        e.preventDefault();
                        pos.description && navigator.clipboard.writeText(pos.description);
                    }}
                    title="Kliknij prawym, aby skopiować opis"
                >
                    {pos.description || "-"}
                </CopyBox>
            </TableCell>
            <TableCell sx={{ width: "10%" }}>{pos.quantity}</TableCell>
            <TableCell sx={{ width: "16%" }}>
                {Number(pos.grossPrice).toLocaleString("pl-PL", { minimumFractionDigits: 2 })} PLN
            </TableCell>
            <TableCell sx={{ width: "10%" }}>{pos.vat}</TableCell>
            <TableCell sx={{ width: "16%" }}>
                {(Number(pos.grossPrice) * Number(pos.quantity)).toLocaleString("pl-PL", { minimumFractionDigits: 2 })} PLN
            </TableCell>
            <TableCell sx={{ width: "12%" }}>
                <Box display='flex'>
                    <CircularProgress sx={{ mr: 1, mt: 1, visibility: `${zdLoading ? 'visible' : 'hidden'}` }} size={30} />
                    <TextField
                        value={zd}
                        onChange={(e) => handleChangeZd(e.target.value)}
                        placeholder="ZD"
                        fullWidth
                        sx={{
                            minWidth: 120,
                            maxWidth: 150,
                            background: "#fff",
                            borderRadius: 1,
                            fontSize: 14,
                            color: 'red'
                        }}
                    />
                </Box>
            </TableCell>
        </TableRow>
    )
}

export default PositionItem;